import { render, staticRenderFns } from "./ModalKhongCoVeThanTaiBanSo.vue?vue&type=template&id=1281b621&scoped=true&"
import script from "./ModalKhongCoVeThanTaiBanSo.vue?vue&type=script&lang=js&"
export * from "./ModalKhongCoVeThanTaiBanSo.vue?vue&type=script&lang=js&"
import style0 from "./ModalKhongCoVeThanTaiBanSo.vue?vue&type=style&index=0&id=1281b621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1281b621",
  null
  
)

export default component.exports